import axios from 'axios'
import router from '../../router'
import Cookies from 'js-cookie'

// state
const state = {
	user: {},
	header: {},
	avatarUrl: '',
	isActive: false,
	usernameErr: false,
	passwordErr: false,
	isInvalid: false,
	accountLockedType: null, // 'temporary' | 'permanent' | null
	g: '',  // grant type
	i: '',  // client id
	s: '',  // client secret
	l: '',  //api url
	a: '',  //access token
	timeOutVar: null // container for the login timeout
}

const getters = {
	getUserProfileImage(state) {
		var img;
		var imageApi = state.l + 'files?file=';

		if (typeof state.user.profile_image !== 'undefined' && state.user.profile_image !== null) {
			img = "<img width='20' height='20' src='" + imageApi + state.user.profile_image + "' class='img-round'/>";
		} else {
			img = "<img width='20' height='20' src='" + imageApi + "avatars/default.png' class='img-round'/>";
		}

		return img
	},

	getAvatarUrl(state) {
		var url = '';
		if (state.user.profile_image !== null && state.user.profile_image !== '') {
			url = state.l + 'files?file=' + state.user.profile_image;
		} else {
			url = state.l + 'files?file=avatars/0.png';
		}

		return url;
	},

	getInvalid(state) {
		return state.isInvalid
	}
}


// mutations
const mutations = {
	SET_HEADER(state, header) {
		state.header = {
			headers: {
				Authorization: header
			}
		};
		//need to set this because services/auth.js check for this.
		// localStorage.setItem("AUTHENTICATED","authenticated");
		// 
		// for non-www
		Cookies.set("AUTHENTICATED", "authenticated", { expires: 1, path: '/' });
	},

	SET_USER(state, user) {
		state.user = user
		//localStorage.setItem("USER", JSON.stringify(user.data));

		// set user in cookie as well for multiple tabs
		Cookies.set("USER", JSON.stringify(user), { expires: 1, path: '/' });
	},

	SET_LOGOUT(state) {
		//localStorage.removeItem("TOKEN")
		//localStorage.removeItem("USER")
		// redirect to login page
		window.location.href = '/login';

		state.user = {};
		state.header = {};
		state.a = '';
		// localStorage.clear();
		// sessionStorage.clear();
		localStorage.removeItem("TOKEN")
		localStorage.removeItem("USER")

		// delete cookies on logout
		Cookies.remove("USER");
		Cookies.remove("TOKEN");
		Cookies.remove("AUTHENTICATED");
	},

	SET_INVALID_LOGOUT(state) {
		state.user = {}
		state.header = {}
		state.a = ''
		localStorage.clear()
		localStorage.removeItem("TOKEN")
		localStorage.removeItem("USER")

		// delete cookies on logout
		Cookies.remove("USER");
		Cookies.remove("TOKEN");
		Cookies.remove("AUTHENTICATED");
	},

	SET_PAGE_REFRESH(state) {
		//localStorage.setItem("TOKEN", btoa(state.a))
		//localStorage.setItem("USER", JSON.stringify(state.user))
	},

	SET_PAGE_DONE(state) {
		// only set url
		state.l = import.meta.env.VITE_URL;

		// if(localStorage.getItem("TOKEN") !== null && localStorage.getItem("TOKEN") !== ''){
		// 	state.a = atob(localStorage.getItem("TOKEN"))
		// 	state.header = {
		// 		headers: {
		// 			Authorization: 'Bearer '.concat(state.a)
		// 		}
		// 	};
		// } else 
		if (Cookies.get("TOKEN") !== null && Cookies.get("TOKEN") !== '') {
			state.a = atob(Cookies.get("TOKEN"))
			state.header = {
				headers: {
					Authorization: 'Bearer '.concat(state.a)
				}
			};
		}

		// if(localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' && localStorage.getItem("USER") !== 'undefined'){
		// 	state.user = JSON.parse(localStorage.getItem("USER"))
		// } else 
		if (Cookies.get("USER") !== null && Cookies.get("USER") !== '' && Cookies.get("USER") !== 'undefined') {
			state.user = JSON.parse(Cookies.get("USER"))
		}

		//localStorage.removeItem("TOKEN")
		//localStorage.removeItem("USER")
	},

	SET_VARIABLES(state) {
		state.g = import.meta.env.VITE_GRANT_TYPE
		state.i = import.meta.env.VITE_CLIENT_ID
		state.s = import.meta.env.VITE_CLIENT_SECRET
		state.l = import.meta.env.VITE_URL
	},

	SET_TOKEN(state, token) {
		state.a = token

		// Set Token for multiple tabs
		Cookies.set("TOKEN", btoa(token), { expires: 1, path: '/' });  // for non-www
	},

	SET_TIME_OUT_VAR(state, timeOut) {
		state.timeOutVar = timeOut
	},

	SET_AVATAR_URL(state, url) {
		state.avatarUrl = url;
	},

	TOGGLE_BOOLEAN_STATE(state, { key, bool }) {
		eval('state.' + key + ' = bool');
	},

	SET_ACCOUNT_LOCKED_TYPE(state, type) {
		state.accountLockedType = type;
	},

	RESET(){
		localStorage.clear();
		sessionStorage.clear();
	}
}

// actions
const actions = {
	setBoolean({ commit }, { key, bool }) {
		commit('TOGGLE_BOOLEAN_STATE', { key: key, bool: bool });
	},

	setAccountLockedType({ commit }, type) {
		commit('SET_ACCOUNT_LOCKED_TYPE', type);
	},

	setVariables({ commit }) {
		commit('SET_VARIABLES');
	},

	logout({ commit, dispatch }) {
		commit('SET_LOGOUT')
		dispatch('clearTimeOut')
	},

	pageRefresh({ commit }) {
		commit('SET_PAGE_REFRESH')
	},

	pageDone({ commit, dispatch }) {
		commit('SET_PAGE_DONE')
		//setTimeout(function(){ dispatch('getAvatarUrl'); }, 500);
	},

	checkError({ commit }, error) {
		if (typeof error.response !== 'undefined') {
			if (error.response.status == '404' || error.response.status == '401') {
				//commit('SET_LOGOUT')
				// display session expired modal
				VueStore.dispatch('notify/setShowMessage', { key: 'showSessionExpired', bool: true });
				console.log(error.response.status);
			} else {
				console.log(error.response.status)
			}
		}
	},

	checkErrorAjax({ commit, dispatch }, error) {
		if (typeof error.responseJSON.message !== 'undefined') {
			if (error.responseJSON.status == '401') {
				//commit('SET_LOGOUT')

				//VueStore.dispatch('notify/setShowSessionExpired', true);
				// display session expired modal
				VueStore.dispatch('notify/setShowMessage', { key: 'showSessionExpired', bool: true });

				console.log(error.responseText);
			} else {
				console.log(error.responseText)
			}
		}
	},

	authenticate({ commit, state }, user) {
		commit('SET_ACCOUNT_LOCKED_TYPE', null);
		var data = {
			grant_type: state.g,
			client_id: state.i,
			client_secret: state.s,
			username: user.username,
			password: user.password
		}

		axios.post(state.l + 'accessToken', data)
			.then(response => {
				//commit('SET_AUTHENTICATE', response.data);
				//console.log(response);
				// get user role
				if (response.data.access_token) {
					//localStorage.setItem("token", response.data.access_token)
					const header = 'Bearer '.concat(response.data.access_token);
					commit('SET_HEADER', header);
					commit('SET_TOKEN', response.data.access_token);
					axios.get(state.l + 'v1/users/me', {
						headers: {
							Authorization: header
						}
					})
						.then(response => {
							//console.log(response);
							if (response.status == '200') {
								// only allow client user
								//console.log(response.data.data.role);
								commit('RESET');
								if (response.data.data.role == "VENDOR_USER") {
									var user = response.data.data;

									commit('SET_USER', user)

									//Redirect to home
									router.push({ name: 'items', params: { items: 'welcome' }, query: { id: '1', display_name: 'Welcome' } })

									setTimeout(function () {
										commit('TOGGLE_BOOLEAN_STATE', { key: 'isActive', bool: false });
									}, 500);

									commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: false });
								} else {
									commit('TOGGLE_BOOLEAN_STATE', { key: 'isActive', bool: false });
									commit('SET_ACCOUNT_LOCKED_TYPE', null);
									commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: true });
									commit('SET_INVALID_LOGOUT');
								}
							} 
						})
						.catch((error) => {
							console.log(error);
							commit('SET_ACCOUNT_LOCKED_TYPE', null);
							commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: true });
						});
				} else {
					commit('TOGGLE_BOOLEAN_STATE', { key: 'isActive', bool: false });
					commit('SET_ACCOUNT_LOCKED_TYPE', null);
					commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: true });
				}
			})
			.catch((error) => {
				commit('TOGGLE_BOOLEAN_STATE', { key: 'isActive', bool: false });
				const data = error.response && error.response.data;
				const isAccountLocked = data && data.status === 'error' && (data.message === 'Accounted Locked' || data.message === 'Account Locked');
				const lockType = data && data.type;
				if (isAccountLocked && (lockType === 'temporary' || lockType === 'permanent')) {
					commit('SET_ACCOUNT_LOCKED_TYPE', lockType);
					commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: false });
				} else {
					commit('SET_ACCOUNT_LOCKED_TYPE', null);
					commit('TOGGLE_BOOLEAN_STATE', { key: 'isInvalid', bool: true });
				}
				console.log(error);
			});
	},

	setTimeOutVar({ commit }, timeOut) {
		commit('SET_TIME_OUT_VAR', timeOut);
	},

	clearTimeOut({ state }) {
		//console.log('CLEAR TIMEOUT: ' + state.timeOutVar);
		clearTimeout(state.timeOutVar);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}